import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { usePageHeaderStore } from './pageHeader'

/** Renders a page's own controls into the header bar, beside the avatar. */
export function HeaderSlot({ children }: { children: ReactNode }) {
  const slot = usePageHeaderStore((s) => s.slot)
  return slot ? createPortal(children, slot) : null
}
